import { EmailDraft, EmailMessage, EmailThread, ReplyRecipients } from '../models/Email';
import { EmailContactData } from '../models/EmailContact';

export const MAX_OTHER_RECIPIENTS = 49;

const findRepliedToMessage = (
  data: EmailContactData | undefined,
  thread: EmailThread | undefined
): EmailMessage | undefined => thread?.messages.find(message => message.contactId === data?.contactId);

export const getReplyRecipients = (
  data: EmailContactData | undefined,
  thread: EmailThread | undefined,
  draft: EmailDraft | undefined
): ReplyRecipients =>
  draft?.replyRecipients ?? {
    to: data?.from ? [data.from] : [],
    otherRecipients: findRepliedToMessage(data, thread)?.otherRecipients?.map(recipient => recipient.emailAddress) ?? []
  };

// Until the replied-to email's content has loaded, its other recipients are unknown rather than empty.
export const isRepliedToEmailLoaded = (data: EmailContactData | undefined, thread: EmailThread | undefined): boolean =>
  Boolean(findRepliedToMessage(data, thread)?.contentLoaded);

export const areReplyRecipientsSendable = ({ to, otherRecipients }: ReplyRecipients): boolean =>
  to.length === 1 && otherRecipients.length <= MAX_OTHER_RECIPIENTS;
